import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import React from "react";
import {
    SEAckToString,
    SEIdToString,
    SETypeToString,
    SafetyEventTypeOperator,
    resolveSafetyEventTypeOperator,
} from "stores/ApplicationFilters/Filters/SafetyEvent";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";

const idPrefix = "application-filters-safety-event-chip";

export const SafetyEventChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    const safetyEvent = applicationFiltersStore.safetyEvent;
    if (safetyEvent === undefined ||
        (safetyEvent.identification === null &&
            safetyEvent.types.length === 0 &&
            safetyEvent.acknowledgments.length === 0))
        return null;

    return (
        <>
            {safetyEvent.identification !== null && (
                <AppliedFilterChip
                    id={`${idPrefix}-${SEIdToString(safetyEvent.identification)
                        .replaceAll(" ", "-")
                        .toLowerCase()}`}
                    disabled={props.disabled}
                    isApplicable={props.isApplicable}
                    onRemove={() =>
                        applicationFiltersStore.setSafetyEvent({
                            identification: null,
                        })
                    }
                >
                    Safety Event: {SEIdToString(safetyEvent.identification)}
                </AppliedFilterChip>
            )}
            {resolveSafetyEventTypeOperator(safetyEvent) === SafetyEventTypeOperator.And &&
            safetyEvent.types.length > 0 ? (
                <AppliedFilterChip
                    id={`${idPrefix}-types-all`}
                    disabled={props.disabled}
                    isApplicable={props.isApplicable}
                    onRemove={() =>
                        applicationFiltersStore.setSafetyEvent({ types: [] })
                    }
                >
                    Safety Event Type: ALL{" "}
                    {safetyEvent.types.map(SETypeToString).join(", ")}
                </AppliedFilterChip>
            ) : (
                safetyEvent.types.map((type) => (
                    <AppliedFilterChip
                        key={type}
                        id={`${idPrefix}-${SETypeToString(type)
                            .replaceAll(" ", "-")
                            .toLowerCase()}`}
                        disabled={props.disabled}
                        isApplicable={props.isApplicable}
                        onRemove={() =>
                            applicationFiltersStore.setSafetyEvent({
                                types: applicationFiltersStore.safetyEvent?.types.filter(
                                    (t) => t !== type,
                                ),
                            })
                        }
                    >
                        Safety Event Type: {SETypeToString(type)}
                    </AppliedFilterChip>
                ))
            )}
            {safetyEvent.acknowledgments.map((acknowledgment) => (
                <AppliedFilterChip
                    key={acknowledgment}
                    id={`${idPrefix}-${SEAckToString(acknowledgment)
                        .replaceAll(" ", "-")
                        .toLowerCase()}`}
                    disabled={props.disabled}
                    isApplicable={props.isApplicable}
                    onRemove={() =>
                        applicationFiltersStore.setSafetyEvent({
                            acknowledgments:
                                applicationFiltersStore.safetyEvent?.acknowledgments.filter(
                                    (ack) => ack !== acknowledgment,
                                ),
                        })
                    }
                >
                    Safety Event: {SEAckToString(acknowledgment)}
                </AppliedFilterChip>
            ))}
        </>
    );
});
